const starterCode = {
    declaringVars: 
`x = -2
y = 5
my_age = 18
message = "Hey! How are you doing?"`,

    printing:
`x = -2
print(x)
print("Hello World!")`,

    printArt:
`print("                        \\ \\\\")
print("                         \\ \\\\")
print("                          | |")
print("                          | |")
print("        /\\---/\\   _,---._ | |")
print("       /^   ^  \,'       \`. ;")
print("      ( O   O   )           ;")
print("       \`.=o=__,'            \\\\")
print("         /         _,--.__   \\\\")
print("        /  _ )   ,'   \`-. \`-. \\\\")
print("       / ,' /  ,'        \\\\ \\\\ \\\\ \\\\")
print("      / /  / ,'          (,_)(,_)")
print("     (,;  (,,)")
`,

    dataTypes:
`# Integers
y = -15

# Booleans
is_weekend = True
is_holiday = False

# Strings
first_name = "Lionel"
last_name = "Messi"
full_name = first_name + " " + last_name
print(full_name) # returns Lionel Messi

# Lists
fruits = ["banana", "kiwi", "apple"]
print(fruits[0]) # returns banana
print(fruits[2]) # returns apple
# print(fruits[3]) causes an error, index 3 is out of range and does not exist`,

    ifStatements:
`my_age = 18
if my_age >= 18:
    print("You can vote!")
else:
    print("Can't vote just yet!")`,

    grade:
`def get_grade(grade):
    if grade >= 90:
        return "A"
    elif grade >= 80:
        return "B"
    elif grade >= 70:
        return "C"
    elif grade >= 60:
        return "D"
    else:
        return "F"
print(get_grade(61))`,

    operators:
`== # Check if two values are equal
>= # Check if the first value is greater or equal to the second
<= # Less than or equal
>  # Strictly greater
<  # Strictly less than
!= # Check if two values are unequal`,

    conjunctiveOperators:
`number_of_chores = 3
is_weekend = True
# If it is the weekend or a weekday where you have less than 2 chores
if is_weekend == True or (is_weekend == False and number_of_chores < 2):
    print("You can play video games")
else:
    print("Finish your chores or wait for the weekend")`,

    stringIndexing:
`my_string = "Hello World!"
my_string[3] # returns l
my_string[5] # returns empty space, which is a character too`,

    lenFunction:
`fruits = ["banana", "kiwi", "apple"]
name = "Turing"
print(len(fruits)) # returns 3
print(len(name)) #returns 6`,

    basicLoop:
`for i in range(0, 11):
    print(i)`,

    countZero:
`my_list = [0, 1, 1, 0, 0, 0]
# Variable to keep track of how many 0 we come across
number_of_zeroes = 0
for i in range(0, len(my_list)):
    # If current item is a 0
    if my_list[i] == 0:
        # Increment number_of_zeroes
        number_of_zeroes = number_of_zeroes + 1
print(number_of_zeroes)`,

    getDNAComplement:
`def get_complement(dna):
    complement = ""
    for i in range(0, len(dna)):
        if dna[i] == "A":
            complement += "T"
        elif dna[i] == "T":
            complement += "A"
        elif dna[i] == "C":
            complement += "G"
        elif dna[i] == "G":
            complement += "C"
    return complement
print(get_complement("ATCGGACT"))`,

    stringSlicing:
`fruits = ["banana", "kiwi", "apple"]
print(fruits[0:2]) # returns 0th and first item, banana and kiwi
print(fruits[1:3]) # returns 1st and 2nd item, kiwi and apple
message = "Hello World!"
print(message[0:5]) # returns Hello
print(message[6:11]) # returns World
`
}

export default starterCode;
